import { Fragment, type FC } from "react";
import { Box, Button } from "@mui/material";
import { FoodsIcon, FoodsIconButton } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import { useApplicationParameters } from "src/api/client-api/appParams/useApplicationParameters";
import { exportSsqToExcel } from "./exportSsqToExcel";
import { Post } from "src/api/client-api/post/postSchema";
import { SsqVersion } from "src/api/sure-api/ssq/useGetOneSsqVersion.ts";
import { ExportSubject } from "src/utils/exportNaming";

type ExportSSQIconButtonProps = {
    ssqVersion: SsqVersion;
    post: Post;
    subject: ExportSubject;
};

export const ExportSSQIconButton: FC<ExportSSQIconButtonProps> = ({ ssqVersion, post, subject }) => {
    const { t } = useTranslation();
    const { isFeatureActivated } = useApplicationParameters();

    const handleExport = () => {
        const excelHeaders = [
            t("ssq.export.excel.theme"),
            t("ssq.export.excel.subtheme"),
            t("ssq.export.excel.parentquestion"),
            t("ssq.export.excel.question"),
            t("ssq.export.excel.reponsegroup"),
            t("ssq.export.excel.reponse"),
            t("ssq.export.excel.unit"),
            t("ssq.export.excel.type"),
            t("ssq.export.excel.type.document"),
            t("ssq.export.excel.type.comment"),
        ];

        exportSsqToExcel(excelHeaders, ssqVersion, post, subject);
    };

    if (!isFeatureActivated("FS-ssq-export-excel")) {
        return null;
    }

    return (
        <Fragment>
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
                <Button
                    variant="secondary"
                    startIcon={<FoodsIcon size={2} icon={"exportDownload"} />}
                    onClick={handleExport}
                >
                    {t("ssq.export.excel.button.label2", "Export (Excel)")}
                </Button>
            </Box>
            <Box sx={{ display: { xs: "block", sm: "none" } }}>
                <FoodsIconButton
                    size={"s"}
                    icon={"exportDownload"}
                    withBackground
                    buttonProps={{
                        onClick: handleExport,
                    }}
                />
            </Box>
        </Fragment>
    );
};
